module.exports = __webpack_public_path__ + "static/img/block-1.c82ad689.png";